<style scoped>
  .label{
    position: relative;
    float: left;
    display: inline-block;
    vertical-align: top;
    width: 120px;
    padding-right: 6px;
    text-align: right;
    color: #888;
  }
  .label:before{
    content: ':';
    position: absolute;
    top: 0;
    right: 0;
  }
  .value{
    padding-left: 125px;
    white-space: normal;
  }
  .user-flow{
    margin-top: 20px;
  }
  .user-flow .value{
    padding-top: 3px;
    padding-left: 130px;
  }
  .line /deep/ .ivu-table-expanded-cell{
    padding: 20px 4px;
  }
</style>
<template>
  <div style="margin-top:20px">
    <ReceiptBillCard 
      v-model="model"
      :show-action="false"
    />
  </div>
</template>
<script>
  import ReceiptBillCard from '@/views/fin_bill/components/receipt_bill_card'
  import Util from '@/libs/util';
  const { fin_receipt_bill_detail} = Util.api
  export default {
    components: { ReceiptBillCard},
    props: {
      model_id: {
        type: Number
      },
      receipt_type: {
        type: String
      }
    },
    data() {
      return {
        getValue: false,
        model: {},
      }
    },
    computed: {
      get_value() {
        return !!Object.values(this.model).length
      },
    },
    created() {
     
    },
    mounted() {
      Util.http.get(fin_receipt_bill_detail, { id: this.model_id }).then(data => {
        this.model = (data && data.bill) || {}
      })
    },
    methods: {

    }
  }
</script>
